export default {
    TimeCondition: {
        getdata: []
    },
};